export const FOOD_RECOGNITION_ENDPOINT = "/api/food-recognition";
export const MAX_FOOD_PHOTO_BYTES = 4 * 1024 * 1024;

export type FoodRecognitionConfidence = "low" | "medium" | "high";

/**
 * An intentionally editable estimate. Photo recognition cannot establish an
 * exact serving or nutrition label, so every result requires user review.
 */
export interface RecognizedFoodDraft {
  name: string;
  brand?: string;
  basisAmount: 1;
  basisUnit: "serving";
  servingName?: string;
  proteinGrams: number;
  carbohydrateGrams: number;
  fatGrams: number;
  fibreGrams: number;
  micronutrients: [];
  sourceLabel: "Photo estimate";
  requiresMacroReview: true;
}

export interface FoodRecognitionResult {
  draft: RecognizedFoodDraft;
  confidence: FoodRecognitionConfidence;
  description: string;
  assumptions: string[];
}

export const FOOD_RECOGNITION_SERVER_ERROR_CODES = [
  "invalid_request",
  "image_too_large",
  "unsupported_image",
  "no_food",
  "not_configured",
  "rate_limited",
  "upstream_error",
  "timeout",
  "invalid_response",
] as const;

export type FoodRecognitionServerErrorCode = (typeof FOOD_RECOGNITION_SERVER_ERROR_CODES)[number];
export type FoodRecognitionErrorCode = FoodRecognitionServerErrorCode | "offline" | "network_error";

export class FoodRecognitionError extends Error {
  constructor(
    message: string,
    readonly code: FoodRecognitionErrorCode,
    readonly status?: number,
    readonly retryAfterSeconds?: number,
  ) {
    super(message);
    this.name = "FoodRecognitionError";
  }
}
